import styled, { css } from "styled-components"
import { breakpoints } from "@config/theme"
import { Box } from "@components/Layout"

export const GalleryWrapper = styled(Box)<{ isSingle: boolean }>`
  display: grid;
  grid-template-columns: 12% 88%;
  grid-column-gap: 1rem;
  height: auto;
  width: 100%;
  position: relative;
  overflow: visible;

  @media screen and (max-width: ${breakpoints.small}) {
    display: flex;
  }

  @media screen and (min-width: ${breakpoints.small}) {
    overflow: hidden;
  }

  ${(p) =>
    p.isSingle &&
    css`
      grid-template-columns: 88%;
    `}
`

export const ThumbnailWrapper = styled(Box)`
  flex: 0 0 16%;
  max-height: 100%;
  /* overflow-y: auto; */

  @media screen and (max-width: ${breakpoints.small}) {
    display: none;
  }
`

export const Thumbnail = styled.button<{ active: boolean; img: string }>`
  width: 100%;
  background-image: url("${(p) => p.img}");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  margin-bottom: 0.75rem;
  box-shadow: inset 0 0 0 ${(p) => p.theme.colors.purple};
  transition: box-shadow 0.1s ease-in-out;
  cursor: pointer;
  outline: none;
  border: none;
  padding: 0;

  &:before {
    content: "";
    padding-top: 100%;
    box-shadow: inset 0 0 0 ${(p) => p.theme.colors.purple};
    transition: box-shadow 0.1s ease-in-out;
    display: block;
  }

  ${(p) =>
    p.active &&
    css`
      &:before {
        box-shadow: inset 0 -2px 0 ${(p) => p.theme.colors.purple};
        background-color: rgba(255, 255, 255, 0.7);
      }
    `};
`

export const ImageContainer = styled(Box)`
  flex: 0 0 84%;
  position: relative;
  width: 100%;

  &:after {
    padding-top: 105%;
    content: "";
    display: block;
  }

  @media screen and (max-width: ${breakpoints.small}) {
    flex: 0 0 100%;

    &:after {
      padding-top: 100%;
      content: "";
      display: block;
    }
  }
`
export const Image = styled.img<{ active: boolean }>`
  transition: opacity 0.2s ease-in-out;
  object-fit: cover;
  object-position: center;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: ${(p) => (p.active ? 1 : 0)};
`

export const NavButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  height: 3.5rem;
  width: 3.5rem;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.1);
  border-radius: 100%;
  pointer-events: all;
  outline: 0;
  border: none;
  svg {
    width: 1.25rem;
    height: 1.25rem;
    fill: ${(p) => p.theme.colors.purple};
  }
`

export const NavContainer = styled(Box)`
  display: flex;
  pointer-events: none;
  justify-content: space-between;
  width: 100%;
  position: absolute;
  top: 50%;

  ${NavButton} {
    &:first-of-type {
      transform: translate(-25%, -50%);
    }
    &:nth-of-type(2) {
      transform: translate(25%, -50%);
    }
  }

  @media screen and (min-width: ${breakpoints.small}) {
    display: none;
  }
`
